// extracted by mini-css-extract-plugin
module.exports = {"aheadPreview":"styles_aheadPreview__2Twxr","svgContainer":"styles_svgContainer__34gcQ"};